import Skeleton from "react-loading-skeleton";
import { Field, FieldGroup, Fieldset } from "@/components/catalyst/Fieldset";

export function AppSettingsSkeleton() {
	return (
		<Fieldset>
			<FieldGroup className="grid grid-cols-1 gap-x-12 gap-y-10 sm:grid-cols-2">
				<div className="space-y-6">
					<Skeleton className="h-8 w-40" height={32} width={160} />
					<div className="flex items-center gap-4">
						<Skeleton
							className="h-6 w-12 rounded-full"
							circle
							height={24}
							width={48}
						/>
						<Skeleton className="h-4 w-20" width={80} />
					</div>
				</div>

				<div className="space-y-6">
					<Skeleton className="h-8 w-40" height={32} width={160} />
					<div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
						<div className="flex items-center gap-4">
							<Skeleton className="h-4 w-12" width={48} />
							<Skeleton
								className="h-6 w-12 rounded-full"
								circle
								height={24}
								width={48}
							/>
						</div>
						<div className="flex items-center gap-4">
							<Skeleton className="h-4 w-12" width={48} />
							<Skeleton
								className="h-6 w-12 rounded-full"
								circle
								height={24}
								width={48}
							/>
						</div>
					</div>
				</div>

				<Field className="col-span-full">
					<Skeleton className="mb-2 h-4 w-32" width={128} />
					<Skeleton className="h-10 w-full rounded-lg" height={40} />
				</Field>

				<Field>
					<Skeleton className="mb-2 h-4 w-32" width={128} />
					<Skeleton className="h-40 w-full rounded-lg" height={160} />
				</Field>

				<Field>
					<Skeleton className="mb-2 h-4 w-32" width={128} />
					<Skeleton className="h-10 w-full rounded-lg" height={40} />
				</Field>

				<Field className="col-span-full">
					<Skeleton className="mb-2 h-4 w-48" width={192} />
					<Skeleton className="h-32 w-full rounded-lg" height={128} />
				</Field>
			</FieldGroup>
		</Fieldset>
	);
}
